import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { BedDouble, Bath, Maximize, MapPin, Home as HomeIcon } from "lucide-react";
import { imgSrc, eur } from "@/lib/api";

const PropertyCard = ({ p, index = 0 }) => (
  <motion.article
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ y: -6 }}
    className="h-full"
  >
    <Link
      to={`/propiedades/${p.id}`}
      data-testid={`property-card-${p.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-2xl border border-gold/20 bg-ink2/80 shadow-[0_10px_30px_rgba(0,0,0,0.8)] backdrop-blur-xl transition-colors duration-500 hover:border-gold/50"
    >
      <div className="relative overflow-hidden">
        {p.images && p.images[0] ? (
          <img
            src={imgSrc(p.images[0])}
            alt={p.title}
            loading="lazy"
            className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="flex aspect-[4/3] w-full items-center justify-center bg-surface text-gold/40">
            <HomeIcon size={44} />
          </div>
        )}
        <span
          className={`absolute left-4 top-4 rounded-full px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] ${
            p.operation === "venta" ? "btn-gold-metallic text-ink" : "border border-gold/50 bg-ink/80 text-gold"
          }`}
        >
          {p.operation}
        </span>
        <span className="absolute bottom-4 right-4 rounded-full border border-gold/30 bg-ink/80 px-4 py-1.5 font-serif text-lg text-gold backdrop-blur">
          {eur(p.price)}
          {p.operation === "alquiler" && <span className="text-xs text-stone2"> /mes</span>}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-3 p-5">
        <h3 className="font-serif text-xl leading-snug text-ivory transition-colors group-hover:text-gold">{p.title}</h3>
        <p className="flex items-center gap-2 text-sm text-stone2">
          <MapPin size={14} className="text-gold-subtle" /> {p.location}
        </p>
        <div className="mt-auto flex items-center gap-5 border-t border-gold/10 pt-4 text-[13px] text-stone2">
          {p.bedrooms > 0 && (
            <span className="flex items-center gap-1.5" data-testid="property-spec-bedrooms">
              <BedDouble size={16} className="text-gold-subtle" /> {p.bedrooms}
            </span>
          )}
          {p.bathrooms > 0 && (
            <span className="flex items-center gap-1.5" data-testid="property-spec-bathrooms">
              <Bath size={16} className="text-gold-subtle" /> {p.bathrooms}
            </span>
          )}
          {p.area > 0 && (
            <span className="flex items-center gap-1.5" data-testid="property-spec-area">
              <Maximize size={16} className="text-gold-subtle" /> {p.area} m²
            </span>
          )}
          <span className="ml-auto text-[11px] uppercase tracking-[0.2em] text-gold-subtle">{p.ref}</span>
        </div>
      </div>
    </Link>
  </motion.article>
);

export default PropertyCard;
